import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import Item from "./Item";
import { MallListApi } from "./api";
import { IMall } from "shared/types/malls";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { setId, setName } from "shared/redux/reducers/MallSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { mallSelect } from "shared/redux/selectors/mall";

const SelectMallContent: React.FC = () => {
  const { id } = useAppSelector(mallSelect);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState<IMall | null>(null);
  const [mallsList, setMallsList] = useState<IMall[]>([]);

  useEffect(() => {
    MallListApi()
      .then((res) => {
        setMallsList(res);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (id) {
      mallsList.forEach((item) => {
        if (item.id === id) {
          setActive(item);
          return;
        }
      });
    }
  }, [id, mallsList]);

  useEffect(() => {
    if (active) {
      localStorage.setItem("mall_id", String(active.id));
      localStorage.setItem("mall_name", active.title);

      dispatch(setName(active.title));
      dispatch(setId(active.id));

      if (!localStorage.getItem("mall_id")) {
        navigate(ROUTES_PATH.HOME);
      }
    }
  }, [active]);

  return (
    <ul className={s.content}>
      {loading ? (
        <li>Загрузка...</li>
      ) : (
        mallsList?.map((item) => (
          <Item {...item} key={item.id} active={active} setActive={setActive} />
        ))
      )}
    </ul>
  );
};

export default SelectMallContent;
